import React, { Component } from "react";
import { Layout, Menu, Button } from "antd";
import { ShoppingCartOutlined, LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import { notification } from "antd";
import "./MenuLayout.css";
import { connect } from "react-redux";
import { getOrderItemChoices } from "../services/orderItems";
import ItemList from "../components/itemList";
import { itemTypeChoices } from "../utils/itemType";
import BasketModal from "../components/basketModal";
const { Header, Content, Footer } = Layout;

const notiMethods = ["post", "put", "delete"];

class MenuLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      selectedMenu: ["recommended"],
      dataLoading: false,
      basketModalVisible: false
    };
    this.onMenuClicked = this.onMenuClicked.bind(this);
    this.setBasketModalVisible = this.setBasketModalVisible.bind(this);
    this.getItem = this.getItem.bind(this);
  }

  onMenuClicked(menuName) {
    this.setState(
      {
        selectedMenu: [menuName],
      },
      async () => {
        await this.getItem();
      }
    );
  }

  setBasketModalVisible(val) {
    this.setState({
      basketModalVisible: val
    })
  }

  async getItem() {
    this.setState(
      {
        dataLoading: true,
      },
      async () => {
        const { q, selectedMenu } = this.state;
        const paramObj = {};
        if (selectedMenu[0] === "recommended") {
          paramObj["is_recommended"] = true;
        } else {
          paramObj["item_type"] = selectedMenu[0];
        }

        const result = await getOrderItemChoices(
          q,
          paramObj,
          1,
          1000000,
          "name",
          "ASC"
        );
        this.setState({
          data: result.data.results,
          dataLoading: false,
        });
      }
    );
  }

  async componentWillMount() {
    axios.interceptors.request.use(
      function (config) {
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        // Overide message if role is ADMIN
        let messageTitle = "เรียบร้อย!";
        let messageDescription =
          response.config.successMessage || "ทำรายการสำเร็จลุล่วง";

        if (
          response.status === 200 &&
          notiMethods.includes(response.config.method)
        ) {
          notification.destroy();
          notification["success"]({
            message: messageTitle,
            description: messageDescription,
          });
        }
        return response;
      },
      function (error) {
        notification.destroy();
        notification["error"]({
          message: `เกิดข้อผิดพลาด (${error.response.status})`,
          description: error.response.data.error,
        });

        return Promise.reject(error); // dont' throw here!!! each function need to handle 500 individually
      }
    );
    this.getItem();
  }

  render() {
    const { totalItems, totalPrice } = this.props;
    const { selectedMenu, data, dataLoading, basketModalVisible } = this.state;
    return (
      <>
        <div
          style={{
            width: "100%",
            height: 40,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: "fixed",
            backgroundColor: "#151275",
            zIndex: 1000,
            color: 'white',
            fontSize: 20,
            fontWeight: 700
          }}
        >
          <span>โรงแรมทิพย์อู่ทอง</span>
        </div>
        <Layout style={{ minHeight: "100vh" }}>
          <Header style={{ position: "fixed", zIndex: 1, top: 40 }}>
            <Menu
              mode="horizontal"
              selectedKeys={selectedMenu}
              style={{ minWidth: 900, fontSize: 16 }}
            >
              <Menu.Item
                key="recommended"
                onClick={() => this.onMenuClicked("recommended")}
              >
                {/* <ScheduleOutlined style={{ marginRight: 5 }} /> */}
                สินค้าแนะนำ
              </Menu.Item>
              {itemTypeChoices.map((itc) => (
                <Menu.Item
                  key={itc.value}
                  onClick={() => this.onMenuClicked(itc.value)}
                >
                  {/* <DollarOutlined style={{ marginRight: 5 }} /> */}
                  {itc.name}
                </Menu.Item>
              ))}
            </Menu>
          </Header>
          <Content
            className="site-layout"
            style={{ padding: "0 25vh", marginTop: 64 }}
          >
            <div
              className="site-layout-background"
              style={{
                padding: 0,
                paddingTop: 40,
                height: "100%",
                overflowY: "scroll",
                paddingBottom: 80,
              }}
            >
              {dataLoading ? (
                <div
                  style={{
                    width: "100%",
                    height: '80vh',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LoadingOutlined style={{fontSize: 50}} spin />
                </div>
              ) : (
                <ItemList data={data} />
              )}
            </div>
          </Content>
          <Footer
            style={{
              position: "fixed",
              zIndex: 1,
              bottom: 0,
              backgroundColor: "white",
              width: "100%",
              height: 80,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Button
                type="primary"
                size="large"
                style={{
                  marginRight: 5,
                  width: "60vw",
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 16
                }}
                onClick={this.setBasketModalVisible}
              >
                <span>
                  <ShoppingCartOutlined /> {totalItems} ชิ้น
                </span>{" "}
                <span>{totalPrice} บาท</span>
              </Button>
            </div>
          </Footer>
        </Layout>
        <BasketModal visible={basketModalVisible} setVisible={this.setBasketModalVisible}/>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    totalItems: state.basket.totalItems,
    totalPrice: state.basket.totalPrice,
  };
};

export default connect(mapStateToProps)(MenuLayout);
